import React from 'react';
import GuidelineCard from "./components/guidelineCard";
import YoutubeModal from "./components/youtubeModal";
import DataLoader from "../../components/loader/dataLoader";
import useGuidelines from "../../hooks/public/useGuidelines";
import '../../assets/css/pages/guidelines/style.scss';

const GuidelinesPage = () => {
    const {data, isLoading} = useGuidelines();

    return (
        <section className='guideline-section'>
            <div className='custom-container'>
                <div className='content-section'>
                    <h1 className='page-title'>Guideline</h1>
                    <div className='content-body'>
                        {isLoading && <DataLoader/>}
                        <div className="guidelines-grid">
                            {
                                data && data?.map((guideline) =>
                                    <div key={guideline.id} className="card-container">
                                        <GuidelineCard key={guideline.id} guideline={guideline}/>
                                    </div>
                                )
                            }
                        </div>
                        <div className="text-center">
                            <YoutubeModal/>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default GuidelinesPage;
